var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02943 16.9706 3 12 3M12 21C7.02943 21 3 16.9706 3 12C3 7.02943 7.02943 3 12 3M12 21C14.0928 21 15.7895 16.9706 15.7895 12C15.7895 7.02943 14.0928 3 12 3M12 21C9.90713 21 8.21053 16.9706 8.21053 12C8.21053 7.02943 9.90713 3 12 3M3.47368 9.15789H20.5263M3.47368 14.8421H20.5263",
    stroke: "#5D697C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.1a5306d093f294f43da8cdfadb1e9008.svg";
export { ForwardRef as ReactComponent };